import styled, { css } from 'styled-components';

import { ASSET_PATH } from '../../assetsPath';
import { GenericSpan, FlexDiv, Card } from '../common/Styles';

export const ImageBannerWrap = styled.div`
	height: 575px;
	padding-top: 80px;
  background-image: url(${ASSET_PATH.IMAGES}landingPageBanner.png) ;
	@media (max-width: 700px) {
		padding-top: 20px;
	}
`;

export const LandingPageSection = styled.div`
	width:${(props) => props.width ? props.width : 'auto'}
	margin: ${(props) => props.margin ? props.margin : '0px'}
	& .doubleArrw--item {
		align-self: center;
	}
	.InnerSelct__multi-value__remove, .InnerSelct__indicator {
		color: #f17531
	}
`;

export const TrainLandingWrapper = styled.div`
		${(props) => props.isMobile && css`
		& .shortlisterror {
			position: fixed;
			height: 422px;
			top: calc(100vh - 422px);
			& .content {
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
				box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
			}
		}
	`}
`;

export const PassengerDetailsWrapper = styled.div`
	${(props) => props.isMobile && css`
	margin-bottom: 80px;
		& .modalWrapper .content {
			background: #F5F5F5;
		}
		& .modal-mobileHeader {
			background: #fff ;
		}
	`}
`;

export const BulletWrap = styled(FlexDiv)`
  background-image: linear-gradient(111deg, #ff4b59 14%, #ff674b 122%);
`;

export const ListItem = styled.p`
  width: 85%;
  color: #000000;
`;

export const ListLi = styled.li`
	display: flex;
	align-items:center;
	margin-bottom: 32px
`;

export const CardView = styled(Card)`
    border:solid 0.7px #d7d7d7;
    width: ${(props) => props.$width ? props.$width : '100%'};
		height: ${(props) => props.height ? props.height : 'auto'};
`;

export const TrainIcon = styled(GenericSpan) `
    background: url(${ASSET_PATH.IMAGES}/trainFormsSprite.png) no-repeat;
    background-size: 200px 200px;
    display: inline-block;
    ${(props) => {
		switch (props.icon) {
			case 'icTrain':
				return css`
				width: 43px; height: 58px; background-position: -2px -31px;`;
			case 'doubleArrow':
				return css`
				width: 40px; height: 40px; background-position: -52px -31px;
				`;
			case 'delete':
				return css`
				width: 15px; height: 17px; background-position: -50px -5px;`;
			case 'icAdd':
				return css`
				width: 13px; height: 13px; background-position: -5px -5px; margin-right: 5px`;
			case 'icDownArrow':
				return css`
				width: 13px; height: 8px; background-position: -125px -18px;`;
			default:
				break;
		}
	}}
`;

export const TravellerDetailsWrap = styled(FlexDiv)`
  padding: 20px 16px;
  border: solid 1px #e7e7e7;
`;

export const AddTravellerWrapper = styled(FlexDiv)`
  padding: 20px 16px;
  background-color: #f7f7f7;
`;

export const Link = styled.a`
font-weight: 900;
font-size: 14px;
`;

export const Notification = styled.div`
  background: #fff5e6;
  border-radius: 2px;
  color: #cf8100;
  padding: 6px 8px;
	margin-bottom: 10px;
	font-size: 14px;
`;

export const MobileButtonWrapper = styled.div`
	position: fixed;
	bottom: 0px;
	padding: 10px 10px;
	width: 100vw;
	height: 68px;
	background: #FFFFFF;
	box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.16);
`;

export const EditButton = styled.div `
 position: relative;
 font-size: 20px;
 padding-left: 15px;
 .edit_arrow {
   top: 2px;
   right: 15px;
   left: auto;
 }
 width: 12%;
`;

export const MobHeader = styled(FlexDiv)`
	background:#fff;
	box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.11);
	z-index:1;
`;
